var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mb-2"},_vm._l((_vm.items),function(value,key){return _c('div',{key:key},[(_vm.isMarkdown(key))?_c('ReMarkdown',{attrs:{"value":key}}):_c('span',{staticClass:"key"},[_vm._v(_vm._s(key))]),_vm._v(": "),_c('ReNoteJsonValue',{attrs:{"value":value}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }